import { dictEntity } from 'shared';
import type { Dict } from '@aviata/platform-types';

const getCityName = (iata: string, dict: Dict.Entity) => {
  const cityIata = iata.slice(0, 3);
  return dictEntity.lib.getCity(cityIata, dict).name;
};

export const mapSearchesLib = {
  getCityName,
};
